<template>
  <fieldset class="tab tab-04">
    <div class="heading-form a-center">
      <span class="number">4/11</span>
      <p class="c-yellow">ข้อมูลส่วนตัว</p>
      <h2 class="heading-h2 c-white">ที่อยู่ปัจจุบันของคุณ</h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for="" class="icw-label overlabel"
              >เลขที่<!--<span class="c-star"><sup>*</sup></span>--></label
            >
            <input
              type="text"
              id="txtAddress"
              :class="{ 'input-required': !address.addr_no.trim() && isError }"
              v-model="address.addr_no"
              maxlength="10"
            />
            <!-- <p class="input-note c-red" v-if="!address.addr_no.trim() && isError">กรุณากรอกให้ครบถ้วน</p> -->
          </div>
        </li>

        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for="" class="icw-label overlabel">หมู่</label>
            <InputPattern
              type="text"
              id="txtVillageNo"
              v-model="address.addr_moo"
              maxlength="10"
              :regExp="/^[0\D]*|\D*/g"
              pattern="\d*"
            />
          </div>
        </li>

        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for="" class="icw-label overlabel">ซอย</label>
            <input type="text" id="txtAlley" v-model="address.addr_soi" maxlength="50" />
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for="" class="icw-label overlabel">อาคาร / หมู่บ้าน</label>
            <input
              type="text"
              id="txtVillage"
              v-model="address.addr_building"
              maxlength="100"
            />
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="select select_tab">
            <label for="" class="icw-label overlabel"
              >จังหวัด<!--<span class="c-star"><sup>*</sup></span>--></label
            >
            <select
              id="selectProvince"
              class="show-tick form-control"
              :class="{ 'input-required': !address.addr_province && isError }"
              v-model="address.addr_province"
              @change="ProvinceSelect($event)"
            >
              <option value="">เลือกจังหวัด</option>
              <option
                v-for="val in geo.Province"
                :key="'province_' + val.id"
                :value="val.name"
                :data-province-id="val.id"
                >{{ val.name }}</option
              >
            </select>
            <!-- <p class="input-note c-red" v-if="!address.addr_province && isError">กรุณากรอกให้ครบถ้วน</p> -->
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="select select_tab">
            <label for="" class="icw-label overlabel"
              >เขต / อำเภอ<!--<span class="c-star"><sup>*</sup></span>--></label
            >
            <select
              id="selectDistrict"
              class="show-tick form-control"
              :class="{ 'input-required': !address.addr_district && isError }"
              v-model="address.addr_district"
              @change="DistrictSelect($event)"
            >
              <option value="">เลือกเขต</option>
              <option
                v-for="val in geo.District"
                :key="'district_' + val.id"
                :value="val.name"
                :data-district-id="val.id"
                >{{ val.name }}</option
              >
            </select>
            <!-- <p class="input-note c-red" v-if="!address.addr_district && isError">กรุณากรอกให้ครบถ้วน</p> -->
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="select select_tab">
            <label for="" class="icw-label overlabel"
              >แขวง / ตำบล<!--<span class="c-star"><sup>*</sup></span>--></label
            >
            <select
              id="selectSubDistrict"
              class="show-tick form-control"
              :class="{
                'input-required': !address.addr_subdistrict && isError
              }"
              title="กรุณาเลือก"
              v-model="address.addr_subdistrict"
            >
              <option value="">เลือกแขวง</option>
              <option
                v-for="val in geo.Subdistrict"
                :key="'sub_district_' + val.id"
                :value="val.name"
                >{{ val.name }}</option
              >
            </select>
            <!-- <p class="input-note c-red" v-if="!address.addr_subdistrict && isError">กรุณากรอกให้ครบถ้วน</p> -->
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for="" class="icw-label overlabel"
              >รหัสไปรษณีย์<!--<span class="c-star"><sup>*</sup></span>--></label
            >
            <InputPattern
              id="txtPostcode"
              type="text"
              :class="{ 'input-required': !isZipCodeValid }"
              v-model="address.addr_zipcode"
              maxlength="5"
              :regExp="/^[0\D]*|\D*/g"
              pattern="\d*"
            />
            <p class="input-note c-red" v-if="!isZipCodeValid">
              ระบุเฉพาะตัวเลข 5 หลัก
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-04', 'tab-03')"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      type="button"
      id="btnNextStepQ5"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import InputPattern from "vue-pattern-input";

import { my_storage, incCurrentStep } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep1_Q4",
  components: {
    InputPattern
  },
  props: {
    QuestionType: String
  },
  mounted() {
    if (this.address._province_id != "") {
      this.geo.District = _DISTRICT_LIST[this.address._province_id];
      let a = this.address.addr_district;
      setTimeout(function() {
        $("#selectDistrict")
          .find("option[value=" + a + "]")
          .prop("selected", true);
        // $('#selectDistrict').selectpicker('refresh')
      }, 100);
    }

    if (this.address._district_id != "") {
      this.geo.Subdistrict = _SUB_DISTRICT_LIST[this.address._district_id];
      setTimeout(function() {
        // $('#selectSubDistrict').selectpicker('refresh')
      }, 100);
    }
  },
  data() {
    return {
      isZipCodeValid: true,
      address: {
        addr_no: my_storage(this.QuestionType, "addr_no"),
        addr_building: my_storage(this.QuestionType, "addr_building"),
        addr_soi: my_storage(this.QuestionType, "addr_soi"),
        addr_moo: my_storage(this.QuestionType, "addr_moo"),
        addr_province: my_storage(this.QuestionType, "addr_province"),
        addr_district: my_storage(this.QuestionType, "addr_district"),
        addr_subdistrict: my_storage(this.QuestionType, "addr_subdistrict"),
        addr_zipcode: my_storage(this.QuestionType, "addr_zipcode"),
        _province_id: my_storage(this.QuestionType, "_province_id"),
        _district_id: my_storage(this.QuestionType, "_district_id")
      },
      geo: {
        Province: _PROVINCE_LIST,
        Province_ID: 0,
        District: [],
        District_ID: 0,
        Subdistrict: []
      }
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    validZipccode() {
      this.isZipCodeValid = true;
      let pass = true;
      // if (this.address.addr_zipcode == '' || this.address.addr_zipcode.length < 5) {
      if (
        this.address.addr_zipcode != "" &&
        this.address.addr_zipcode.length < 5
      ) {
        pass = false;
      }
      if (!pass) this.isZipCodeValid = false;
      return pass;
    },
    beforeNextStep() {
      // if ((
      // this.address.addr_no.trim() != '' &&
      // this.address.addr_province != '' &&
      // this.address.addr_district != '' &&
      // this.address.addr_subdistrict != '' &&
      this.validZipccode();
      // )) {
      sessionStorage.setItem(
        this.QuestionType,
        JSON.stringify(this._data.address)
      );

      let currentTag = this.$vnode.componentOptions.tag;
      currentTag = currentTag.replace("Q", "");
      incCurrentStep("step1", currentTag);

      this.isError = false;

      this.nextStep("tab-04", "tab-05");
      // } else {
      //   this.validZipccode()
      //   this.isError = true
      // }
    },
    ProvinceSelect(event) {
      this.geo.Province_ID = $(event.target)
        .find("option:selected")
        .data("province-id");
      this.address._province_id = this.geo.Province_ID;
    },
    DistrictSelect(event) {
      this.geo.District_ID = $(event.target)
        .find("option:selected")
        .data("district-id");
      this.address._district_id = this.geo.District_ID;
    }
  },
  watch: {
    "geo.Province_ID": function(n, o) {
      this.geo.District = _DISTRICT_LIST[n];
      this.geo.Subdistrict = [];
      setTimeout(function() {
        // $('#selectDistrict').selectpicker('refresh')
      }, 100);
    },
    "geo.District_ID": function(n, o) {
      this.geo.Subdistrict = _SUB_DISTRICT_LIST[n];
      setTimeout(function() {
        // $('#selectSubDistrict').selectpicker('refresh')
      }, 100);
    }
  },
  computed: {
    isPass() {
      return (
        // this.address.addr_no.trim() != '' &&
        // this.address.addr_province != '' &&
        // this.address.addr_district != '' &&
        // this.address.addr_subdistrict != '' &&
        this.validZipccode()
      );
    }
  }
};
</script>
